import DashboardFilters from "../DashboardFilters";
import DashboardHeader from "../DashboardHeader";
import DashboardTable from "../DashboardTable";
import NotificationsList from "./NotificationsList";
import NotificationTemplatesList from "./NotificationTemplatesList";

export default function NotificationTemplates() {

    const data = {
        data: {
            data: [
                {
                    id: 1,
                    title: "title",
                    body: "body body body body body body body body body body body body body body body"
                },
                {
                    id: 2,
                    title: "title",
                    body: "body body body body body body body body body body body body body body body"
                },
                {
                    id: 3,
                    title: "title",
                    body: "body body body body body body body body body body body body body body body"
                },
                {
                    id: 1,
                    title: "title",
                    body: "body body body body body body body body body body body body body body body"
                },
                {
                    id: 1,
                    title: "title",
                    body: "body body body body body body body body body body body body body body body"
                },
                {
                    id: 1,
                    title: "title",
                    body: "body body body body body body body body body body body body body body body"
                },
                {
                    id: 1,
                    title: "title",
                    body: "body body body body body body body body body body body body body body body"
                },
                {
                    id: 1,
                    title: "title",
                    body: "body body body body body body body body body body body body body body body"
                },
                {
                    id: 1,
                    title: "title",
                    body: "body body body body body body body body body body body body body body body"
                },
                {
                    id: 1,
                    title: "title",
                    body: "body body body body body body body body body body body body body body body"
                },
            ]
        }
    }

    const buttons = [
        { label: 'Back', color: 'bg-white', border: 'border border-b-2', icon: null, shadow: null, onClick: null, linkTo: "/notifications" },
    ]

    const details = {
        title: "Notifications Templates",
        count: data?.length,
    };

    const tableData = {
        headLabels: ["ID", "Title", "Body"],
        list: <NotificationTemplatesList notifications={data?.data.data} />,
        data: data?.data.data,
        actions: true,
    };

    return (
        <>
            <DashboardHeader buttons={buttons} details={details} />
            <hr />
            {/* <DashboardFilters filters={filters} /> */}
            <div className="w-full">
                <DashboardTable tableData={tableData} />
            </div>

        </>
    )
}